import {useCallback} from 'react';
import {postNorafUpdatesIgnorelist} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const usePostNorafUpdateIgnoreItem = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (nationalId: string, agentId: string, name: string, mock?: boolean) => {
      return postNorafUpdatesIgnorelist(
        getTokens,
        nationalId,
        agentId,
        name,
        mock,
      );
    },
    [getTokens],
  );
};
